import { render, staticRenderFns } from "./ProductCharacteristics.vue?vue&type=template&id=6116f8a0&scoped=true&"
import script from "./ProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./ProductCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./ProductCharacteristics.vue?vue&type=style&index=0&id=6116f8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116f8a0",
  null
  
)

export default component.exports